var exports = {
  "WA": "x1cb7f6e3--9eb885--label-row",
  "Pf": "x1cb7f6e3--9eb885--label",
  "Sd": "x1cb7f6e3--9eb885--guide-link",
};

module.exports = exports;
